import React from 'react';
import { Breadcrumb as AntBreadcrumb } from 'antd';
import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  text: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  const capitalizeFirstLetter = (str: string | null | undefined) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <AntBreadcrumb
      separator=">"
      className="text-[16px] text-[#75A7AD] font-semibold mt-[20px]"
    >
      {items.map((item, index) => (
        <AntBreadcrumb.Item key={index}>
          {item.href ? (
            <Link
              to={item.href}
              className="hover:text-[#FF8200] cursor-pointer transition-colors"
            >
              {capitalizeFirstLetter(item.text)}
            </Link>
          ) : (
            <span className=" text-[#75A7AD]">
              {capitalizeFirstLetter(item.text)}
            </span>
          )}
        </AntBreadcrumb.Item>
      ))}
    </AntBreadcrumb>
  );
};

export default Breadcrumb;
